import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#F9FAFB]">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="max-w-3xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#D86C1E] mb-4">
            What We Do
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tight leading-tight text-[#0A0A0A]">
            Every Roofing Service, Under One Trusted Name
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-gray-600">
            From a missing shingle or a single cracked tile to a full commercial install, Schuyler handles it all —
            with the craftsmanship Arizona homes and businesses deserve.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-[#E5E7EB]">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="group relative border-b border-r border-[#E5E7EB] bg-white p-8 transition-colors hover:bg-[#0A0A0A] cursor-default"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="flex h-12 w-12 items-center justify-center bg-[#D86C1E]/10 group-hover:bg-[#D86C1E] transition-colors">
                    <Icon className="h-6 w-6 text-[#D86C1E] group-hover:text-white transition-colors" />
                  </div>
                  <ArrowUpRight className="h-5 w-5 text-gray-300 group-hover:text-[#D86C1E] transition-colors" />
                </div>
                <h3 className="font-heading text-xl font-bold text-[#0A0A0A] group-hover:text-white transition-colors mb-3">
                  {s.title}
                </h3>
                <p className="text-sm leading-relaxed text-gray-600 group-hover:text-white/70 transition-colors">
                  {s.blurb}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
